(() => {
    const delay = require('lodash/delay');

    document.addEventListener("DOMContentLoaded", () => {
        const components = document.querySelectorAll(".highcharts__wrapper");

        if (components.length) {
            /**
             * Add a message to the charts if they haven't
             * initialised after a few seconds.
             *
             * This is the catch the issue where the charts
             * library hasn't been enabled for the current
             * page by the content editor.
             */
            delay(() => {
                if (!window.chartsEnabled) {
                    [ ...components ].forEach(cmp => {
                        const loadingWrapper = cmp.querySelector(".highcharts__loading-container");

                        if (loadingWrapper) {
                            loadingWrapper.innerHTML =
                            `<div class="feedback-label feedback-label--warning">
                                <span class="status-icon status-icon--warning">
                                    <svg class="status-icon__svg"><use xlink:href="#status-warning"></use></svg>
                                </span>
                                <p class="body-size-sm feedback-label__text">Unable to load the chart. Make sure you have enabled the chart library from the Metadata screen via the <strong>Interactive Charts</strong> option.</p>
                            </div>`;
                        }
                    });
                }
            }, 8000);
        }
    });
})();
